import type { OrganizationAttendanceListItem } from "../types/attendances";

/**
 * Determines whether an attendance record is eligible for approval or rejection.
 *
 * @param attendance - The attendance record to check.
 * @returns `true` when the attendance has ended and is still pending.
 */
export function getCanApproveAttendance(attendance: OrganizationAttendanceListItem): boolean {
	if (attendance.type === "break") return false;
	return !!attendance.endTime && attendance.state === "pending";
}
